import { basicInitialState } from 'store/_utils/basicInitialState';
import { TVesselState } from './vesselModel';

export const vesselInitialState: TVesselState = {
  ...basicInitialState,
  isNotFound: false,
  photos: null,
  vessel: null
};
